"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ImageWrapper = exports.Div = exports.ContentWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eq76ntf3"
} : {
  target: "eq76ntf3",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:grid;grid-template-columns:", props.hasImage ? '200px 1fr' : '1fr', ";grid-column-gap:2em;grid-row-gap:1em;align-items:start;@media screen and (max-width: ", _breakpoints.default.medium, "){grid-template-columns:1fr;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const ImageWrapper = exports.ImageWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eq76ntf2"
} : {
  target: "eq76ntf2",
  label: "ImageWrapper"
})("overflow:hidden;max-width:100%;display:flex;align-items:baseline;img{width:100%;max-height:100%;border-radius:16px;@media screen and (max-width: ", _breakpoints.default.medium, "){max-height:175px;width:unset;max-width:100%;min-width:150px;}}");
const ContentWrapper = exports.ContentWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eq76ntf1"
} : {
  target: "eq76ntf1",
  label: "ContentWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1uo1im9",
  styles: "display:grid;grid-template-columns:1fr;grid-row-gap:1.5em"
} : {
  name: "1uo1im9",
  styles: "display:grid;grid-template-columns:1fr;grid-row-gap:1.5em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Div = exports.Div = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eq76ntf0"
} : {
  target: "eq76ntf0",
  label: "Div"
})(process.env.NODE_ENV === "production" ? {
  name: "1mf0dqx",
  styles: "p{margin:0;}h1,h2,h3,h4,h5{margin-top:0;margin-bottom:0;}button{align-self:start;}&>span{display:inline-block;margin-bottom:1em;}"
} : {
  name: "1mf0dqx",
  styles: "p{margin:0;}h1,h2,h3,h4,h5{margin-top:0;margin-bottom:0;}button{align-self:start;}&>span{display:inline-block;margin-bottom:1em;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});